import DataLayerHelper from 'src/utils/setDataLayer';
import apiUrl from '../config/apiUrl';
import { IrtIpgInitializeModel } from '../models/request/IrtIpgInitialize.model';
import { IrtWithdrawInilializeModel } from '../models/request/IrtWithdrawInilialize.model';
import fetchUrl from '../utils/fetchUrl';

export const IRT_IPG_INITIALIZE = async (data: IrtIpgInitializeModel) => {
  DataLayerHelper('deposite IRR', { valuewithirr: data.amount });
  return await fetchUrl({
    url: `${apiUrl}irt/ipg/initialize`,
    method: 'POST',
    body: data,
  });
};
export const IRT_WITHDRAW_INITIALIZE = async (
  data: IrtWithdrawInilializeModel,
) => {
  DataLayerHelper('withdraw IRR', { valuewithirr: data.amount });
  return fetchUrl({
    url: `${apiUrl}irt/withdraw/initialize`,
    method: 'POST',
    body: data,
  });
};
export const VERIFY_WITHDRAW_IRT = async (code: string) => {
  return await fetchUrl({
    url: `${apiUrl}irt/withdraw/verify-withdrawal-irt`,
    method: 'POST',
    body: { code },
  });
};
